<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>سؤال الجمهور</h2>
            <!--<p>الخطوة الثانية: بيانات الطالب</p>-->
        </div>
    </div>
</div>

<div class="service-details ptb-100">
    <div class="container">
        <div class="row align-items-center">


            <p>الرجاء أختيار السؤال</p>

            <div class="">
                <div class="content left-content">






                    <a *ngFor="let item of questionData" class="default-btn m-3" (click)="onClickQuestion(item.aqQuestionID)" href="javascript:void(0);">
                        <i class="bx bxs-edit"></i>{{ item.title }}<span></span>
                    </a>



                </div>

            </div>
        </div>


    </div>
</div>

